import type { SYSAction } from "../../../../../../../_ovlclient/src"
import { Data } from "../../../../../../../_ovlclient/src/dataapi"
import { MergeDeep } from "../../../../../../../_ovlclient/src/global/actions"
import { T } from "../../../../../../../_ovlclient/src/global/globals"
import { SnackAdd } from "../../../../../../../_ovlclient/src/library/snackapi"
import {
  ProcessStart,
  ProcessEnd,
} from "../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"

const FetchQuotations: SYSAction = async (_, { global }) => {
  ProcessStart("GENRefreshData")
  try {
    let state = global.getState()
    let res = await Data("data/getquotations")
    if (!res.data) {
      return
    }
    if (!state.app.screens.DATQuotation.quotationDetail) {
      state.app.screens.DATQuotation.quotationDetail = {
        quotations: res.data,
      }
    } else {
      MergeDeep(state.app.screens.DATQuotation.quotationDetail, {
        quotations: res.data,
      })
    }
  } finally {
    ProcessEnd("GENRefreshData")
  }
}

const FetchQuotationDetail: SYSAction<
  { key: string; silent?: boolean } | string
> = async (value, { global }) => {
  ProcessStart("GENRefreshData")
  try {
    let state = global.getState()
    let payload =
      typeof value === "object" ? value : { key: value, silent: false }
    let res = await Data("data/getquotationdetail", parseInt(payload.key))
    if (!res.data || res.data.attachments.files.length === 0) {
      if (!payload.silent) SnackAdd(T("SYSNoMatchingEntriesFound"), "Warning")
      if (!res.data) return
    }
    MergeDeep(
      state.app.screens.DATQuotation.quotationDetail.quotations[payload.key],
      res.data
    )
  } finally {
    ProcessEnd("GENRefreshData")
  }
}

const HookScreenRefresh: SYSAction = async (_, context) => {
  await FetchQuotations(undefined, context)
}

const HookScreenNavigateIn: SYSAction = async (_, context) => {
  context.global.getState().app.screens.DATQuotation.quotationOverview.activeFilePopup =
    ""
  await FetchQuotations(undefined, context)
}

let hooks = {
  HookScreenRefresh,
  HookScreenNavigateIn,
}

export let DATQuotation = { hooks, actions: { FetchQuotationDetail } }

